import { getMemberRateLimits } from './GetMemberRateLimits';

export const OfficeRateLimitsApi = {
  getMemberRateLimits,
};
